import React, { useState } from "react";

const BannerSlider = () => {
  const slides = [
    {
      image: "images/hero-1.jpg",
      heading: "Fashion Hub",
    },
    {
      image: "images/hero-2.jpg",
      heading: "Formal Dresses",
    },
    {
      image: "images/hero-4.jpg",
      heading: "Plus Size",
    },
    {
      image: "images/hero-5.jpg",
      heading: "Clothing",
    },
    {
      image: "images/hero-3.jpg",
      heading: "Just Arrived",
    },
  ];

  const [activeIndex, setActiveIndex] = useState(0);

  const handleNext = () => {
    setActiveIndex((prev) => (prev + 1) % slides.length);
  };

  const handlePrev = () => {
    setActiveIndex((prev) => (prev - 1 + slides.length) % slides.length);
  };

  return (
    <>
      <div className="slider banner">
        {/* slides */}
        <div className="slider__slides">
          {slides.map((slide, index) => {
            const isActive = index === activeIndex;
            const isPrev =
              index === (activeIndex - 1 + slides.length) % slides.length;
            const className = `slide bg-img ${
              isActive ? "s--active" : isPrev ? "s--prev" : ""
            }`;

            return (
              <div
                key={index}
                className={className}
                style={{
                  background: `url(${slide.image})`,
                  backgroundSize: "cover",
                }}
              >
                <div className="slide__inner">
                  <div className="slide__content">
                    <h2 className="slide__heading">{slide.heading}</h2>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        {/* slides end */}

        {/* Controls */}
        <div className="slider__control" onClick={handlePrev}>
          <div className="slider__control-line" />
          <div className="slider__control-line" />
        </div>
        <div
          className="slider__control slider__control--right m--right"
          onClick={handleNext}
        >
          <div className="slider__control-line" />
          <div className="slider__control-line" />
        </div>
      </div>
    </>
  );
};

export default BannerSlider;
